import './App.css';
import { ConfigProvider, theme } from 'antd';
import { Routes, Route } from 'react-router-dom';

import Home from './pages/home/main';
import Automations from './pages/automate/main';
import Signup from './pages/login/main';
import InstaAccounts from './pages/instaAccounts/main';
import SignupTwo from './pages/signup/main';
import Oia from './pages/oia/main';

import FbRdr from './pages/fb-redirect/main';
import FbAPIRdr from './pages/fb-api-redirect/main';
import { Alert } from 'antd';
import ResetPassword from './pages/reset-password/main';
import YT from './pages/yt-automation/main';
import InboxAutomation from './pages/inbox-automation/main';
import LinkExtract from './pages/linkExtract/main'
// import Shop from './pages/shop/main';
import CollectMoney from './pages/collect-amount/main';
import FlowComp from './pages/flow-automte/main';
import AutomationList from './pages/automationList/main';

import RefferalList from './pages/referal_board/main';
import LinkedIn from './pages/linkedin/main';

import SellMain from './sell_pages/main/main';
import Courses from './pages/courses/main';
import CoursePurchaseFlow from './pages/course_client_side/main';
import IDMDashboard from './pages/dashboard/main';
import DigitalProducts from './pages/digital-products/main';
import DigitalPurchaseFlow from './pages/digital_product_client_side/main';



function App() {
  
  return (
    <ConfigProvider
      button={{
        style: {
          borderRadius: 4
        }
      }}
      input={{
        style: {
          borderRadius: 4
        }
      }}
      modal={{
        style: {
          borderRadius: 4
        }
      }}
    >
      <div className="App">
      
        <Routes>
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Signup />} />
        <Route path="/ig-connect" element={<SignupTwo />} />
        <Route path="/fb-rdr" element={<FbAPIRdr />} />
        <Route path="/fb-api-rdr" element={<FbAPIRdr />} />
        <Route path="/insta-accounts" element={<InstaAccounts />} />
        <Route path="/" element={<Home />} />
        <Route path="/dashboard" element={<IDMDashboard />} />
        <Route path="/home" element={<Home />} />
        <Route path="/manage-post/:id" element={<Automations />} />
        <Route path="/oia" element={<Oia />} />
        <Route path='/reset-password' element={<ResetPassword/>} />
        <Route path="/yt" element={<YT />} />
        <Route path="/inbox-automation" element={<InboxAutomation />} />
        <Route path="/le" element={<LinkExtract />} />
        {/* <Route path="/shop2" element={<Shop/>} /> */}
        <Route path="/shop" element={<SellMain/>} />

        <Route path="/cm" element={<CollectMoney/>} />
        <Route path="/flow" element={<FlowComp />} />
        <Route path="/automation-list" element={<AutomationList />} />
        <Route path = "/referral-dashboard" element={<RefferalList/>} />

        <Route path = "/linkedin" element={<LinkedIn/>} />
        <Route path='/courses' element={<Courses/>}/>
        <Route path='/digital-products' element={<DigitalProducts/>}/>
        <Route path='/course/id' element={<CoursePurchaseFlow/>}/>
        <Route path='/dp/id' element={<DigitalPurchaseFlow/>}/>
        </Routes>

      </div>
    </ConfigProvider>
  );
}

export default App;

